import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://hravahbpnxqisaukjhjg.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhyYXZhaGJwbnhxaXNhdWtqaGpnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ2NzI1NzAsImV4cCI6MjA3MDI0ODU3MH0.XL4FpzSQSbVRTgCUcQ11jN9hIzwSLFN_qTIzZvhc8kI';

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

// Add a connection status check function
export const checkSupabaseConnection = async () => {
  try {
    // Simple query to test connection
    const { error } = await supabase.from('kindness_messages_x7y9z2').select('count', { count: 'exact' }).limit(0);
    
    return {
      connected: !error,
      error: error ? error.message : null
    };
  } catch (err) {
    return {
      connected: false,
      error: err.message
    };
  }
};

export default supabase;